/* cl-slider — devolve MOVIMENTO aos carrosseis copiados do concorrente.
   O markup vem do Swiper dele, mas sem o JS: as setas nao faziam nada e o
   `verify` reprovava o interativo (quick-260806-k9a). Aqui o proprio
   `.swiper` vira um scroller horizontal e as setas rolam um slide. */
(function () {
  function slideStep(wrap) {
    var first = wrap.firstElementChild;
    if (!first) return 0;
    var r = first.getBoundingClientRect();
    var cs = getComputedStyle(first);
    return r.width + (parseFloat(cs.marginRight) || 0);
  }

  function wire(root) {
    root.querySelectorAll('.swiper').forEach(function (sw) {
      if (sw.dataset.clSlider === '1') return;
      var wrap = sw.querySelector('.swiper-wrapper');
      if (!wrap || wrap.children.length < 2) return;
      // NAO mexer no overflow: um container `overflow:hidden` ja e rolavel por
      // scrollLeft, e trocar para `auto` mudava o layout no desktop (a secao de
      // depoimentos caiu de 0.96 para 0.91 so por isso).
      if (getComputedStyle(sw).overflowX === 'visible') return;
      sw.dataset.clSlider = '1';

      var scope = sw.closest('[class*="cl-sec-"], .cl-cart-drawer') || root;
      var go = function (dir) {
        return function (e) {
          e.preventDefault();
          var step = slideStep(wrap) || sw.clientWidth;
          sw.scrollBy({ left: dir * step, behavior: 'smooth' });
        };
      };
      scope.querySelectorAll(
        '.swiper-button-next, .kv-bestseller-next, [aria-label="Next slide"]'
      ).forEach(function (b) { b.addEventListener('click', go(1)); });
      scope.querySelectorAll(
        '.swiper-button-prev, .kv-bestseller-prev, [aria-label="Previous slide"]'
      ).forEach(function (b) { b.addEventListener('click', go(-1)); });
    });
  }

  function boot() {
    document.querySelectorAll('[class*="cl-sec-"], .cl-cart-drawer').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

/* Disclosure (seletor de moeda/pais do rodape): o markup do concorrente e
   `[data-disclosure-toggle]` + `.disclosure-list{display:none}`; sem o JS dele o
   controle ficava morto e o `verify` reprovava o interativo. */
document.addEventListener('click', function (e) {
  var t = e.target && e.target.closest &&
          e.target.closest('[class*="cl-sec-"] [data-disclosure-toggle], [class*="cl-sec-"] .disclosure__toggle');
  if (!t) return;
  e.preventDefault();
  var wrap = t.closest('.disclosure');
  var list = wrap && wrap.querySelector('.disclosure-list');
  var open = t.getAttribute('aria-expanded') === 'true';
  t.setAttribute('aria-expanded', open ? 'false' : 'true');
  if (list) list.classList.toggle('cl-open', !open);
});

/* Abas da grade de colecao: `.tab-button[data-tab]` + `.tab-content#tab-{id}`.
   O JS do concorrente nao vem no markup copiado; sem isto as abas ficam mortas
   e o `verify` reprova o interativo (quick-260806-k9a). */
document.addEventListener('click', function (e) {
  var b = e.target && e.target.closest && e.target.closest('[class*="cl-sec-"] .tab-button[data-tab]');
  if (!b) return;
  e.preventDefault();
  var scope = b.closest('[class*="cl-sec-"]');
  var id = b.getAttribute('data-tab');
  scope.querySelectorAll('.tab-button').forEach(function (x) { x.classList.toggle('active', x === b); });
  scope.querySelectorAll('.tab-content').forEach(function (c) {
    c.classList.toggle('active', c.id === 'tab-' + id);
  });
});

/* Swatch de cor do card: troca a foto e o link do produto (data-image/data-url). */
document.addEventListener('click', function (e) {
  var s = e.target && e.target.closest && e.target.closest('[class*="cl-sec-"] .swatch-color[data-image]');
  if (!s) return;
  e.preventDefault();
  var card = s.closest('.kv-collection-box, .kv-bestseller-slide, li');
  if (!card) return;
  var img = card.querySelector('img');
  if (img) { img.removeAttribute('srcset'); img.src = s.getAttribute('data-image'); }
  var link = card.querySelector('a[href]');
  if (link && s.getAttribute('data-url')) link.href = s.getAttribute('data-url');
  card.querySelectorAll('.swatch-color').forEach(function (x) { x.classList.toggle('is-selected', x === s); });
});
